module.exports = __webpack_public_path__ + "img/01_Casita.ea91153e.jpg";